/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Settings_Section_TitleInputs */



/**
* | output |
* | --- |
* | "Knowledge-base behaviour" |
*
* @param {Rag_Settings_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_settings_section_title = /** @type {((inputs?: Rag_Settings_Section_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Settings_Section_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verhalten der Wissensbasis")
	return /** @type {LocalizedString} */ ("Knowledge-base behaviour")
});